import {
	Button,
	ButtonGroup,
	Link,
	type SxProps,
	Typography,
} from "@mui/material";
import { useActionLoading } from "../hooks/useActionLoading";
import { useSetArchived } from "../hooks/useSetArchived";
import { useSetNonCurrent } from "../hooks/useSetNonCurrent";
import { useSetVerified } from "../hooks/useSetVerified";
import type { MediaGridProps } from "../types";

const sx: SxProps = {
	height: 56,
	borderTopLeftRadius: 0,
	borderBottomLeftRadius: 0,
};

export function BulkActions(props: MediaGridProps) {
	const mediaCodes = props.selectionModel as number[];
	const results = props.staleMedia.rows.results;

	const count = mediaCodes.length;
	const selectedCodes = new Set(mediaCodes);
	const hasNonCurrentSelected = results.some(
		(row) => selectedCodes.has(row.mediaCode) && row.status === "N",
	);

	const { setNonCurrent } = useSetNonCurrent();
	const { setVerified } = useSetVerified();
	const { setArchived } = useSetArchived();

	const actionLoading = useActionLoading();
	const disabled = count < 2 || actionLoading;

	return (
		<ButtonGroup>
			<Button
				color="info"
				disabled={disabled || hasNonCurrentSelected}
				sx={sx}
				onClick={() =>
					props.openModal(`Set ${count} media items to Non-Current?`, () =>
						setNonCurrent(mediaCodes),
					)
				}
			>
				Set Bulk Non-Current
			</Button>
			<Button
				color="success"
				disabled={disabled}
				sx={sx}
				onClick={() =>
					props.openModal(`Verify ${count} media items?`, () =>
						setVerified(mediaCodes),
					)
				}
			>
				Verify Bulk Media
			</Button>
			<Button
				color="error"
				disabled={disabled}
				sx={sx}
				onClick={() =>
					props.openModal(
						<>
							Archive {count} media items? This will store the media in a
							location no longer retrievable in EMC.
							<Typography>
								Contact{" "}
								<Link href="mailto:enginesoftware@catsupport.com">
									enginesoftware@catsupport.com
								</Link>{" "}
								if archived media is needed.
							</Typography>
						</>,
						async () => {
							await setArchived(mediaCodes);
							props.setSelectionModel([]);
						},
					)
				}
			>
				Archive Bulk Media
			</Button>
		</ButtonGroup>
	);
}
